<dw-navbar></dw-navbar>

<!--<dw-sites-filter></dw-sites-filter>-->

<div class="month-selector">
  <label class="ff-cell">
    <span class="ff-label">Month</span>
    <input type="month" name="start" [(ngModel)]="date" (ngModelChange)="dateChanged($event)" max="{{maxDate}}" class="ff-input">
  </label>
</div>

<ul class="main-list">

  <li style="background: #29b2e2; color: #fff; margin: 0; padding: 3px 10px;">US Based</li>

  <li class="ml-item">
    <div>
      <div class="ml-header">

        <div class="ml-cell ml-sidebar">
          <span class="ml-icon">
<!--            <img [src]="site.url + '/api/v1/white-label/images/icon-96x96.png'" *ngIf="site.url" dwErrSrc="{{site.url}}/assets/favicon.png">-->
          </span>
          <span class="ml-name">TOTALS</span>
        </div>

        <div class="ml-cell ml-bar">
<!--          <div class="ff-cell" *ngIf="!sitesMeta[site._id]?.centers">-</div>-->

          <div class="ff-row" style="flex: 100%">
            <div class="ff-col ff-cell single-label" style="flex: 0 0 220px">
              <span class="ff-label"></span>
            </div>
            <div class="ff-col ff-cell single-label" style="flex: 0 0 110px">
              <span class="ff-label text-right">Total Revenue</span>
            </div>
            <div class="ff-col ff-cell single-label" style="flex: 0 0 110px">
              <span class="ff-label text-right">Exempt Revenue</span>
            </div>
            <div class="ff-col ff-cell single-label" style="flex: 0 0 110px">
              <span class="ff-label text-right">Revenue Eligible for Royalties</span>
            </div>

            <div class="ff-col ff-cell single-label" style="flex: 0 0 125px" *ngFor="let fee of this.grandTotals?.fees">
              <span class="ff-label text-right">{{fee.name}}</span>
            </div>

            <div class="ff-col ff-cell single-label" style="flex: 0 0 110px" *ngIf="this.grandTotals?.fees?.length">
              <span class="ff-label text-right">Total Due</span>
            </div>
          </div>

          <div class="ff-row" style="flex: 100%">
            <div class="ff-col ff-cell" style="flex: 0 0 220px">
              <span class="single-value center-name">
<!--                <a href="{{site.url}}/royalty-report-snapshot/{{reportDate}}" target="_blank" rel="noopener">{{center.name}}</a>-->
              </span>
            </div>
            <div class="ff-col ff-cell" style="flex: 0 0 110px; justify-content: center;">
              <span class="ff-stat text-right">
                <span>{{this.grandTotals?.totalRevenue | currency}}</span>
              </span>
            </div>
            <div class="ff-col ff-cell" style="flex: 0 0 110px; justify-content: center;">
              <span class="ff-stat text-right">
                <span>{{this.grandTotals?.exemptRevenue | currency}}</span>
              </span>
            </div>
            <div class="ff-col ff-cell" style="flex: 0 0 110px; justify-content: center;">
              <span class="ff-stat text-right">
                <span>{{this.grandTotals?.royaltiesRevenue | currency}}</span>
              </span>
            </div>

            <div class="ff-col ff-cell" style="flex: 0 0 125px; justify-content: center;" *ngFor="let fee of this.grandTotals?.fees">
              <span class="ff-stat text-right">
                <span>{{fee.amount | currency}} ({{fee.rate}}%)</span>
              </span>
            </div>

            <div class="ff-col ff-cell" style="flex: 0 0 110px; justify-content: center;" *ngIf="this.grandTotals?.fees?.length">
              <span class="ff-stat text-right">
                <span>{{this.grandTotals?.totalDue | currency}}</span>
              </span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </li>

  <li *ngFor="let site of usSites$ | async" class="ml-item" [ngTemplateOutlet]="tplSite" [ngTemplateOutletContext]="{ site: site }"></li>
  <li style="background: #29b2e2; color: #fff; margin: 0; padding: 3px 10px;">International</li>
  <li *ngFor="let site of otherSites$ | async" class="ml-item" [ngTemplateOutlet]="tplSite" [ngTemplateOutletContext]="{ site: site }"></li>
</ul>

<div class="ff-row ml-header" style="justify-content: flex-end; margin-bottom: 30px">
  <button class="ff-btn text-primary" title="Download PDF" (click)="pdf()" [disabled]="isLoading()" [ngClass]="{ dim: isLoading(), spin2: isLoading() }"><i class="fa fa-file-text"></i> PDF</button>
  <button class="ff-btn text-primary" title="Download CSV" (click)="csv()" [disabled]="isLoading()" [ngClass]="{ dim: isLoading(), spin2: isLoading() }"><i class="fa fa-file-text"></i> CSV</button>
</div>

<ng-template #tplSite let-site="site">
  <div>
    <div class="ml-header">

      <div class="ml-cell ml-sidebar" [ngClass]="{ spin1: !this.sitesMeta[site._id]?.centers && !this.sitesMeta[site._id]?.error }">
          <span class="ml-icon">
            <img [src]="site.url + '/api/v1/white-label/images/icon-96x96.png'" *ngIf="site.url" dwErrSrc="{{site.url}}/assets/favicon.png">
          </span>
        <span class="ml-name">{{site.name}}</span>
      </div>

      <div class="ml-cell ml-bar">
        <div class="ff-cell" *ngIf="!sitesMeta[site._id]?.centers">-</div>

        <div class="ff-row" style="flex: 100%" *ngIf="sitesMeta[site._id]?.centers?.length">
          <div class="ff-col ff-cell single-label" style="flex: 0 0 220px">
            <span class="ff-label">Center</span>
          </div>
          <div class="ff-col ff-cell single-label" style="flex: 0 0 110px">
            <span class="ff-label text-right">Total Revenue</span>
          </div>
          <div class="ff-col ff-cell single-label" style="flex: 0 0 110px">
            <span class="ff-label text-right">Exempt Revenue</span>
          </div>
          <div class="ff-col ff-cell single-label" style="flex: 0 0 110px">
            <span class="ff-label text-right">Revenue Eligible for Royalties</span>
          </div>

          <div class="ff-col ff-cell single-label" style="flex: 0 0 125px" *ngFor="let fee of sitesMeta[site._id]?.settings?.franchiseFees">
            <span class="ff-label text-right">{{fee.name}}</span>
          </div>

          <div class="ff-col ff-cell single-label" style="flex: 0 0 110px" *ngIf="sitesMeta[site._id]?.settings?.franchiseFees?.length">
            <span class="ff-label text-right">Total Due</span>
          </div>
        </div>

        <div class="ff-row" style="flex: 100%" *ngIf="sitesMeta[site._id]?.error">
          <div class="ff-col ff-cell" style="flex: auto; justify-content: center;">
              <span class="ff-err">
                <span>{{sitesMeta[site._id].error}}</span>
              </span>
          </div>
        </div>

        <div class="ff-row" style="flex: 100%" *ngFor="let center of sitesMeta[site._id]?.centers">
          <div class="ff-col ff-cell" style="flex: 0 0 220px">
              <span class="single-value center-name" [ngClass]="{ spin1: center.spin }">
                <a href="{{site.url}}/royalty-report-snapshot/{{reportDate}}?center={{center.id}}" target="_blank" rel="noopener">{{center.name}}</a>
              </span>
          </div>
          <div class="ff-col ff-cell" style="flex: auto; justify-content: center;" *ngIf="center.error">
              <span class="ff-err">
                <span>{{center.error}}</span>
              </span>
          </div>
          <div class="ff-col ff-cell" style="flex: 0 0 110px; justify-content: center;" *ngIf="!center.error">
              <span class="ff-stat text-right">
                <span>{{center.totals?.totalRevenue | currency: sitesMeta[site._id]?.currency : 'symbol-narrow'}}</span>
              </span>
          </div>
          <div class="ff-col ff-cell" style="flex: 0 0 110px; justify-content: center;" *ngIf="!center.error">
              <span class="ff-stat text-right">
                <span>{{center.totals?.exemptRevenue | currency: sitesMeta[site._id]?.currency : 'symbol-narrow'}}</span>
              </span>
          </div>
          <div class="ff-col ff-cell" style="flex: 0 0 110px; justify-content: center;" *ngIf="!center.error">
              <span class="ff-stat text-right">
                <span>{{center.totals?.royaltiesRevenue | currency: sitesMeta[site._id]?.currency : 'symbol-narrow'}}</span>
              </span>
          </div>

          <div class="ff-col ff-cell" style="flex: 0 0 125px; justify-content: center;" *ngFor="let fee of center.totals?.fees">
              <span class="ff-stat text-right">
                <span>{{fee.amount | currency: sitesMeta[site._id]?.currency : 'symbol-narrow'}} ({{fee.rate}}%)</span>
              </span>
          </div>

          <div class="ff-col ff-cell" style="flex: 0 0 110px; justify-content: center;" *ngIf="center.totals?.fees?.length">
              <span class="ff-stat text-right">
                <span>{{center.totals?.totalDue | currency: sitesMeta[site._id]?.currency : 'symbol-narrow'}}</span>
              </span>
          </div>
        </div>
      </div>

    </div>
  </div>
</ng-template>
